import React from 'react';
import { commonStyles } from '../styles/commonStyles';

export interface RadioGroupOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  options: RadioGroupOption[];
  value: string | undefined;
  onSelect: (value: string) => void;
  hasError?: boolean;
}

// Shared Ja/Nee pill radio group used by the property screens (Woonhuis/Inboedel/
// Personenauto). Base styling lives in commonStyles; the screen owns the value +
// onSelect data wiring. The error variant only shows on unselected options.
export const RadioGroup: React.FC<RadioGroupProps> = ({ options, value, onSelect, hasError = false }) => (
  <div style={commonStyles.radioGroup}>
    {options.map((option) => {
      const selected = value === option.value;
      const optionStyle = selected
        ? commonStyles.radioOptionSelected
        : hasError
          ? commonStyles.radioOptionError
          : commonStyles.radioOption;
      return (
        <div key={option.value} style={optionStyle} onClick={() => onSelect(option.value)}>
          <div style={selected ? commonStyles.radioDotSelected : commonStyles.radioDot}>
            {selected && <div style={commonStyles.radioDotInner} />}
          </div>
          {option.label}
        </div>
      );
    })}
  </div>
);

export default RadioGroup;
